import { ShieldCheck, Star, MapPin, Layers } from "lucide-react";
import { useReviews } from "@/hooks/usePublicContent";

export default function TrustBar() {
  const { items } = useReviews();
  const count = items.length;
  const avg = count ? (items.reduce((s, r) => s + (r.rating || 0), 0) / count).toFixed(1) : null;

  const signals = [
    avg ? { icon: Star, label: `${avg} rating`, sub: `from ${count} review${count === 1 ? "" : "s"}` } : null,
    { icon: Layers, label: "Rectified experts", sub: "large-format specialists" },
    { icon: ShieldCheck, label: "Fully insured", sub: "European-standard craft" },
    { icon: MapPin, label: "Perth metro", sub: "residential & commercial" },
  ].filter(Boolean);

  return (
    <section data-testid="trust-bar" className="bg-[#0b1120] border-y border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-7 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-6">
        {signals.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="flex items-center gap-3">
              <span className="h-10 w-10 shrink-0 flex items-center justify-center border border-white/15">
                <Icon className="h-4 w-4 text-[#c9a87c]" />
              </span>
              <div>
                <p className="text-white text-sm md:text-base leading-tight">{s.label}</p>
                <p className="text-[0.65rem] md:text-xs uppercase tracking-[0.14em] text-[#94a3b8] mt-0.5">{s.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
